import React, { useState, useEffect } from 'react';
import '../components/TableList.css';
import EventFormModal from '../components/EventFormModal';

export default function AdminEvents() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('name-az');
    const [showAddModal, setShowAddModal] = useState(false);
    const [editingEvent, setEditingEvent] = useState(null);

    const token = localStorage.getItem('adminToken');

    const fetchEvents = async () => {
        setLoading(true);
        try {
            const res = await fetch('https://www.fro.ro/api/admins/get-events.php', {
                headers: { Authorization: 'Bearer ' + token }
            });

            const data = await res.json();

            if (data.success) {
                // doar evenimentele FRO (club_id = 1)
                const filtered = (data.events || []).filter(ev => ev.club_id === "38");
                setEvents(filtered);
                setError(null);
            } else {
                setError(data.message || 'Eroare la încărcarea evenimentelor');
            }
        } catch (err) {
            console.error('Eroare la încărcarea evenimentelor:', err);
            setError('Eroare la conexiune.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEvents();
    }, []);

    const handleDelete = async (eventId) => {
        if (!window.confirm('Sigur dorești să ștergi acest eveniment?')) return;

        try {
            const res = await fetch(`https://www.fro.ro/api/admins/delete-event.php?id=${eventId}`, {
                method: 'DELETE',
                headers: { Authorization: 'Bearer ' + token },
            });
            const data = await res.json();
            if (data.success) {
                setEvents(prev => prev.filter(e => e.id !== eventId));
            } else {
                alert('Eroare la ștergere: ' + data.message);
            }
        } catch (err) {
            alert('Eroare de conexiune: ' + err.message);
        }
    };

    const handleEdit = (event) => {
        setEditingEvent(event);
        setShowAddModal(true);
    };

    const filteredEvents = events.filter(ev =>
        ((ev.name || '') + ' ' + (ev.location || '')).toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedEvents = [...filteredEvents].sort((a, b) => {
        if (sortBy === 'name-az') return (a.name || '').localeCompare(b.name || '');
        if (sortBy === 'location-az') return (a.location || '').localeCompare(b.location || '');
        if (sortBy === 'date') return new Date(a.start_date) - new Date(b.start_date);
        return 0;
    });

    if (loading) return <p>Se încarcă evenimentele...</p>;
    if (error) return <p style={{ color: 'red' }}>{error}</p>;

    return (
        <div className="table-list-container">
            <div className="table-list-header">
                <h2 style={{ flex: 1 }}>Evenimente FRO</h2>

                <div className="sort-bar">
                    <label htmlFor="sort-select" className="sort-label">Sortează:</label>
                    <select
                        id="sort-select"
                        className="sort-select"
                        value={sortBy}
                        onChange={e => setSortBy(e.target.value)}
                    >
                        <option value="name-az">A-Z după nume</option>
                        <option value="location-az">A-Z după locație</option>
                        <option value="date">După dată</option>
                    </select>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1 }}>
                    <input
                        type="text"
                        className="search-bar"
                        placeholder="Caută eveniment..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                    />
                    <button
                        className="add-circle-btn"
                        onClick={() => {
                            setEditingEvent(null);
                            setShowAddModal(true);
                        }}
                        aria-label="Adaugă eveniment"
                    >
                        <span className="plus-icon">+</span>
                    </button>
                </div>
            </div>

            <table className="table-list">
                <thead>
                    <tr>
                        <th>Nume</th>
                        <th>Perioadă</th>
                        <th>Locație</th>
                        <th>Acțiuni</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedEvents.length === 0 ? (
                        <tr>
                            <td colSpan={6}>Nu există evenimente.</td>
                        </tr>
                    ) : (
                        sortedEvents.map(event => (
                            <tr key={event.id}>
                                <td>{event.name}</td>
                                <td>{event.start_date} – {event.end_date}</td>
                                <td>{event.location}</td>
                                <td className="table-list-actions">
                                    <button onClick={() => handleEdit(event)}>Edit</button>
                                    <button onClick={() => handleDelete(event.id)}>Delete</button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {showAddModal && (
                <EventFormModal
                    onClose={() => {
                        setShowAddModal(false);
                        setEditingEvent(null);
                        fetchEvents();
                    }}
                    onEventAdded={fetchEvents}
                    editData={editingEvent}
                />
            )}
        </div>
    );
}
